import axios from 'axios'
import router from './router'
import store from './store'
import { resetRouter, systemRoutes } from "./router";
import { getSession, removeSession, setSession } from "./utils/auth";
import { filterObjectEmpty } from './utils/index.js'
import { Message, Loading } from 'element-ui'
import { setPoint } from '@/utils/setPoint.js'

const clearRequest = {
  source: {
    token: null,
    cancel: null
  }
}

const CancelToken = axios.CancelToken;

//定义loading变量
let loading
//多次请求同时触发处理
let needLoadingRequestCount = 0

//路由拦截
router.beforeEach(async (to, from, next) => {
  const {token, shopCode, jumpFrom, shopName, paramsObj = '{}'} = to.query
  // 插件iframe引入
  if (jumpFrom === 'plugin') {
    // removeSession('name')
    // removeSession('stores')
    // removeSession('plat')
    // removeSession('userId')
    // removeSession('shopName')
    if (token) {
      setSession('token', token)
      setSession('shopCode', shopCode)
      setSession('shopName', shopName)
      sessionStorage.setItem('paramsObj', paramsObj)
      await store.dispatch('plugin/setStatus', 1)
    }
  }
  
  //清除请求
  clearRequest.source.cancel && clearRequest.source.cancel();
  clearRequest.source = CancelToken.source();
  // console.log(clearRequest,'clearRequest----')
  console.log(to, 'to');
  if (to.query.token && to.path === '/login') {
    localStorage.clear()
    let data = {
      token: to.query.token
    }
    await store.dispatch('user/login', data)
    router.replace({ path: '/' })
    return 
  }
  //验证是否登陆
  const hasToken = getSession('token')
  console.log(hasToken, 'hasToken');
  if (hasToken) {
    if (to.path == '/login') {
      next({ path: from.fullPath })
    } else {
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        store.dispatch('navTab/changeNavType', 'add')
        if (to.params.source != 'tab' && to.matched.length >= 3) {
          let payLoad = {
            firDir: to.matched[0].meta.title,
            secDir: to.matched[1].meta.title,
            thirDir: to.matched[2].meta.title,
            function: '进入页面',
            operationDatail: ''
          }
          setPoint(payLoad)
          let menuId = to.meta.menuId || to.matched[to.matched.length - 2].meta.menuId
          let params = {
            menuId: menuId,
            referer: document.domain,
          }
          if (params.menuId) {
            api.addOverviewSystemLoginLogs(params).then(res => {

            })
          }

        }
        next()
      } else {
        try {
          //  查询用户平台
          const plat = await store.dispatch('user/getUserPlat')
          if (plat.code !== 200) return false

          //获取用户菜单权限
          const roles = await store.dispatch('user/getMenu')
          // console.log(roles, '获取用户权限')
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles)


          //获取店鋪
          const shops = await store.dispatch('user/getShop')
          // console.log(accessRoutes,'accessRoutes----')
          //每次添加路由前初始化路由状态
          resetRouter()
          router.addRoutes(accessRoutes)
          if (jumpFrom === 'plugin') {
            next({ path: to.path, replace: true })
            return
          }
          next({ ...to, replace: true })
        } catch (error) {
          //清除token和权限,重新登录
          /*await store.dispatch('user/resetSession')
          next(`/login?redirect=${to.fullPath}`)*/
        }
      }
    }
  } else {
    if (to.path == '/login') {
      next()
    } else {
      // 10.11.13.132 localhost
      if (window.location.hostname == 'localhost') {
        let obj = {
          token: '4c6d054c-e762-4ca0-ae30-80f5a405da47'
        }
        next({
          path: '/login',
          query: obj
        })
      } else {
        location.href = process.env.VUE_APP_BASE_LOGIN
      }
    }
  }
})
//请求拦截
axios.interceptors.request.use(
  config => {
    if (!config.hideLoading) {
      let str = config.isFullScreenLoading ? true : false
      showFullScreenLoading(str)
    }
    config.cancelToken = clearRequest.source.token;
    const token = getSession('token')

    if (token) {

      config.headers.common["AuthorizationMa"] = 'BearerMa ' + token
    }
    //过滤 请求参数为空的字段
    if (config.method == 'get') {
      config.params = filterObjectEmpty(config.params)
    } else {
      config.data = filterObjectEmpty(config.data)
    }
    // if (store.getters.shopCode) {
    //   addRequestData(config, 'sellerId', store.getters.shopCode)
    // } else if (getSession('shopCode')) {
      addRequestData(config, 'sellerId', getSession('shopCode'))
    // }
    return config
  },
  error => {
    return Promise.reject(error);
  }
)

//响应拦截
axios.interceptors.response.use(
  response => {
    if (!response.config.hideLoading) {
      tryHideFullScreenLoading()
    }
    // console.log(response.data,z)
    const res = response.data
    if (res && res.code) {

      switch (res.code * 1) {
        case 200:
          break;
        case 500:
          if (res.code === 500) {
            Message({
              type: 'warning',
              message: res.msg,
              duration: 3000,
              onClose: function () {
                // location.href = API.loginUrl
              }
            })

          }
          break;
        case 401:
          // 用户登录过期 停止剩余请求
          clearRequest.source.cancel && clearRequest.source.cancel();
          clearRequest.source = CancelToken.source();
          store.dispatch('user/resetSession')
          let time = setTimeout(() => {
            Message({
              type: 'warning',
              message: '登录过期，请重新登录',
              duration: 3000,
              onClose: function () {
                location.href = process.env.VUE_APP_BASE_LOGIN
              }
            })
            clearTimeout(time)
          }, 1000)

          break;
        default:

          if (res.code != 200) {
            Message.error(res.msg)
          }
          break;
      }
    }
    return response
  },
  error => {
    tryHideFullScreenLoading()
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      Message.error('请求超时')
    } else {
      if (axios.isCancel(error)) {
        //请求取消
      } else {
        //请求失败
        Message.error(error)
      }
    }
    return Promise.reject(error)
  }
)


//loading配置
function startLoading() {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '拼命加载中',
    fullscreen: true,
    target: 'body',
    customClass: 'loadingClass',
    background: 'rgba(255, 255, 255, 0.9)'
  })
}

function endLoading() {    //使用Element loading-close 方法
  loading.close()
  needLoadingRequestCount = 0
}

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

//请求添加参数
function addRequestData(config, key, value) {
  let data = ''
  if (config.method == 'get') {
    data = config.params || {}
    // console.log(data,'data---')
    data[key] = value
    config.params = data
  } else {
    let url = config.url
    if (url.indexOf('?') > -1) {
      config.url = `${config.url}&${key}=${value}`
    } else {
      config.url = `${config.url}?${key}=${value}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/intercept.js